import ForwarderInfo from './ForwarderInfo';

export type OtherPaymentAllowed  =  'yes' | 'no';

export enum InvoiceAccountType {
  NONE = 'None',
  INVOICE = 'Credit balance',
  PREPAID = 'Pre-paid balance'
};

export default interface ForwarderAccountAndConfig {
  id: number;
  name: string;
  fwdInfo : ForwarderInfo;
  accountBalance: number;
  convenience_fee_usd: number;
  other_payment_allowed: OtherPaymentAllowed;
  type: string;
  pay_by_wallet: boolean
};
